import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";

export const getContext = createAsyncThunk(
    "context/getContext",
    async () => {
        const response = await api.get(`v2/api/auth/context`).catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
        return response.data;
    },
    {
        condition: (args, {getState, extra}) => {
            const {context} = getState();
            if (context.status.type === "loading") {
                // Already fetched or in progress, don't need to re-fetch
                return false;
            }
        },
    }
);
export const postContext = createAsyncThunk(
    "context/getContext",
    async body => {
        const response = await api.post(`v2/api/auth/context`, body).catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
        return response.data;
    },
    {
        condition: (args, {getState, extra}) => {
            const {context} = getState();
            if (context.status.type === "loading") {
                // Already fetched or in progress, don't need to re-fetch
                return false;
            }
        },
    }
);
export const getContextSilent = createAsyncThunk(
    "context/getContextSilent",
    async () => {
        const response = await api.get(`v2/api/auth/context`).catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
        return response.data;
    },
    {
        condition: (args, {getState, extra}) => {
            const {context} = getState();
            if (context.status.type === "loading") {
                // Already fetched or in progress, don't need to re-fetch
                return false;
            }
        },
    }
);
const initialState = {
    company_id: null,
    credential: {},
    challenges: [],
    settings: [],
    permissions: [],
    status: {
        type: "idle",
        error: null,
    },
};
const contextSlice = createSlice({
    name: "context",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        [getContext.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [getContext.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.credential = action.payload.data?.credential;
            state.settings = action.payload.data?.settings;
            state.permissions = action.payload.data?.permissions;
            state.company_id = action.payload.data?.company_id;
            state.challenges = action.payload.data?.challenges;
        },
        [getContext.rejected]: (state, action) => {
            state.status.type = "failed";
        },
        [getContextSilent.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.credential = action.payload.data?.credential;
            state.settings = action.payload.data?.settings;
            state.permissions = action.payload.data?.permissions;
            state.company_id = action.payload.data?.company_id;
            state.challenges = action.payload.data?.challenges;
        },
        [getContextSilent.rejected]: (state, action) => {
            state.status.type = "failed";
        },
    },
});

export const {setInitialState} = contextSlice.actions;
export default contextSlice.reducer;

export const checkPermission = (state, permission_name) =>
    state.context.permissions?.find(permission => permission?.identifier === permission_name);
export const loadParameter = (state, type_name) =>
    state.context.settings?.find(parameter => parameter?.type?.name === type_name)?.value;
export const loadUserParameter = (state, type_name) =>
    state.context.credential?.parameters?.find(parameter => parameter?.type?.name === type_name)?.value;
